export default [ 'preload',
  'scene1',
  'scene2',
  'scene3',
  'scene4',
  'scene5',
  'scene6',
  'scene7',
  'scene8'
]



// WEBPACK FOOTER //
// ./src/templates/coffee/scenes.js